const src = import.meta.ROLLUP_FILE_URL_UtSd2wWiGs0Sim15oE6Xxg;
export default {
  src,
  srcSet: src + " " + 420 + "w",
  width: 420,
  height: 280,
};